var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpQuestionSolidIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "help-question-1--circle-faq-frame-help-info-mark-more-query-question"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fill: "#000000",
    fillRule: "evenodd",
    d: "M14 7A7 7 0 1 1 0 7a7 7 0 0 1 14 0ZM5.75 5.25A1.25 1.25 0 1 1 7 6.5a.75.75 0 0 0-.75.75v.646a.75.75 0 1 0 1.5 0 2.751 2.751 0 1 0-3.5-2.646.75.75 0 0 0 1.5 0ZM8 10.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z",
    clipRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpQuestionSolidIcon);
export default __webpack_public_path__ + "static/media/help-question-solid-icon.3c0d838e8ebcd4889dc1f4a7192ca3d3.svg";
export { ForwardRef as ReactComponent };